import * as yup from 'yup';

export const clientIdSchema = yup
  .object()
  .shape({ employeePortalClientId: yup.string() })
  .defined();

export type DapClientIdSchema = yup.InferType<ReturnType<typeof clientIdSchema>>;
